import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import consumer from "./consumer"

window.Notifications = {
    init: function () {
        const userId = document.body.dataset.currentUserId;
        if (!userId) {
            console.warn("🔕 Notificações desativadas: usuário não logado.");
            return;
        }

        const $bell = $("#notification-bell");
        const $listContainer = $("#notification-list");
        const $badge = $("#notification-count");

        function updateNotificationBadge() {
            $.ajax({
                url: "/notifications/unread_count",
                method: "GET",
                success: function (data) {
                    const count = data.count;
                    if (count > 0) {
                        $badge.text(count > 99 ? "+99" : count).show();
                    } else {
                        $badge.text("").hide();
                    }
                }
            });
        }

        function loadNotifications(useJs = false) {
            $.ajax({
                url: "/notifications/connect.js",
                method: "GET",
                dataType: "script",
                success: function () {
                    updateNotificationBadge();
                }
            });
        }

        $("#mark-all-read").on("click", function () {
            $.ajax({
                url: "/notifications/mark_all_as_read",
                type: "PATCH",
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function () {
                    $(".notification-item").removeClass("unread");
                    updateNotificationBadge();
                }
            });
        });

        const trigger = $("#notification-bell");

        tippy(trigger[0], {
            content: $listContainer[0],
            animation: 'shift-away',
            allowHTML: true,
            trigger: "click",
            interactive: true,
            placement: "bottom-end",
            theme: 'app_theme',
            touch: true,
            onShow(instance) {
                $listContainer.show();
                loadNotifications();
            },
            onMount(instance) {
                var m = $("#{id_dd}".format({ id_dd: instance.popper.getAttribute("id") }));
                m.find(".notification-see-all-btn").click(function () {
                    instance.hide();
                });
                Notifications.tippy = instance;
            },
        });

        let startTime = Date.now();

        consumer.subscriptions.create(
            { channel: "NotificationsChannel" },
            {
                initialized() {
                    console.log("🔁 Canal inicializado");
                },
                connected() {
                    const ms = Date.now() - startTime;
                    console.log(`✅ Connected to NotificationsChannel após ${ms}ms`);
                },
                received(data) {
                    console.log("📨 RECEBIDO EM TEMPO REAL:", data);

                    updateNotificationBadge();

                    if ($("#notification-list").is(":visible")) {
                        loadNotifications();
                    }
                },
                disconnected(event) {
                    const duration = ((Date.now() - startTime) / 1000).toFixed(2);
                    console.warn(`⚠️ Desconectado de NotificationsChannel após ${duration}s`);

                    // Tenta inspecionar `this` ou conexão se possível
                    try {
                        console.log("📉 Estado da conexão ao desconectar:", this);
                    } catch (e) {
                        console.error("❌ Erro ao inspecionar desconexão:", e);
                    }
                },
                rejected() {
                    console.error("❌ Assinatura rejeitada pelo servidor (rejected)");
                }
            }
        );
        loadNotifications();
    }
}

window.consumer = consumer;